import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getDetailsContacts } from '../actions/contactActions'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'

function ContactScreen() {
    const navigate = useNavigate()
    const Id = window.location.pathname.split('/')[2]

    const dispatch = useDispatch();

    const contactDetails = useSelector(state => state.contactDetails)
    const { contactdetail, loading, error } = contactDetails

    const dealList = useSelector(state => state.dealList)
    const { deals, loading: loadingdeal, error: errordeal } = dealList

    const applicationList = useSelector(state => state.applicationList)
    const { applications, loading: loadingapplication, error: errorapplication } = applicationList

    useEffect(() => {
        if (Id == 0) {
            navigate('/')
        } else {
            if (contactdetail.length == 0) {
                dispatch(getDetailsContacts(Id))
                //console.log(contactdetail)
            }
        }
    }, [dispatch, Id])

    return (
        <>
            <Header />
            <LeftComponent >

                <div className="content-body">
                    <div className="container-fluid">
                        <div className="heading-title">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="home-title float-left">
                                        <h1>Contact Details - {Id}</h1>
                                    </div>
                                    {/* <div className="home-table-search">
                                <div className="input-group search-contacts">
                                    <input type="Search" className="form-control" placeholder="search contacts" /><i className="fa fa-search"
                                        aria-hidden="true"></i>
                                </div>
                                <div className="right-click Create-btn">
                                    <a href="javascript:void(0)" className="btn create-contact" onClick="openCreatContact()">Create
                                        Contact</a>
                                </div>
                            </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="inner-body">
                            <div className="row">
                                <div className="col-sm-12 col-md-4 col-lg-4">
                                    <div className="add-filter">
                                        <div className="filter-title  filter-title-mob">
                                            <h5>Basic Information</h5>
                                        </div>
                                        <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                                            <div className='container-fluid'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <label><strong>First Name: </strong></label>
                                                        {contactdetail.First_Name}
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label>Last Name: </label>
                                                        {contactdetail.Last_Name}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-4 col-lg-4">
                                    <div className="add-filter">
                                        <div className="filter-title  filter-title-mob">
                                            <h5>Deals Information</h5>
                                        </div>
                                        <div className="filter-body filter-body-mob custom-scroll-right pt-0">


                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-4 col-lg-4">
                                    <div className="add-filter">
                                        <div className="filter-title  filter-title-mob">
                                            <h5>Application Information</h5>
                                            <button className="mob-nav-open">☰</button>
                                        </div>
                                        <div className="filter-body filter-body-mob custom-scroll-right pt-0">


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LeftComponent>
        </>
    )
}

export default ContactScreen